<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>ACTUALIZACIÓN DE REGISTRO</h1>
                    <p class="mt-3">
						Queremos conocerte más, te invitamos a actualizar tu registro.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3 mb-5">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/listado-ofertas']" class="nav-link m-1">Listado de ofertas</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/listado-proveedor']" class="nav-link m-1">Mis postulaciones</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/actualizacion-registro']" class="nav-link m-1 disabled" tabindex="-1" aria-disabled="true"> Actualizar registro </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/actualizacion-contrasena']" class="nav-link m-1"> Actualizar Contraseña </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/login']" class="nav-link cerrar m-1 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <h3 class="mt-5 mb-3">ACTUALIZA TUS DATOS</h3>
		<div class="row">
			<div class="col-12 mt-3">
                <form #f="ngForm" (ngSubmit)="onSubmit(f)" ngNativeValidate  class="pb-3 row">
                    <div class="form-row">
                        <div class="form-group col-6 text-left">
                            <label for="rfcescrito">RFC</label>
                            <input [(ngModel)]="rfcescrito" name="rfcescrito" type="text" class="form-control" id="rfcescrito" pattern="^[a-zA-Z]{3,4}[0-9]{6}[A-Za-z0-9]{2,3}"minlength="12" maxlength="13" required>
                        </div>
                        <div class="form-group col-6 text-left ">
                            <label for="razonSocial">Razón social</label>
                            <input [(ngModel)]="razonSocial" name="razonSocial" type="text" class="form-control">
                        </div>
                        <div class="form-group col-6 text-left">
                            <label for="calle">Calle</label>
                            <input [(ngModel)]="calle" name="calle" type="text" class="form-control">
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-6 text-left">
                            <label for="nInterior">N. Interior</label>
                            <input [(ngModel)]="nInterior" name="nInterior" type="text" class="form-control" id="nInterior">
                        </div>
                        <div class="form-grou col-lg-3 col-md-3 col-6 text-left">
                            <label for="nExterior">N. Exterior</label>
                            <input [(ngModel)]="nExterior" name="nExterior" type="text" class="form-control" id="nExterior">
                        </div>
                        <div class="form-group col-6 text-left">
                            <label for="colonia">Colonia</label>
                            <input [(ngModel)]="colonia" name="colonia" type="text" class="form-control" id="colonia">
                        </div>
                        <div class="form-group col-6 text-left">
                            <label for="referencia">Referencia</label>
                            <input [(ngModel)]="referencia" name="referencia" type="text" class="form-control" id="referencia">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="correo">Estado</label>
                            <select  [(ngModel)]="idestado" name="idestado" class="form-control" (ngModelChange)="getCiudades($event)" required>
                                <option [ngValue]="" selected>Seleccione Estado</option>
                                <option *ngFor="let estado of estados" [ngValue]="estado.idestado"> {{ estado.nombre | uppercase}} </option>
                            </select>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="correo">Municipio</label>
                            <select [(ngModel)]="idMunicipio" name="idMunicipio" class="form-control">
                                <option *ngFor="let ciudad of ciudades" [ngValue]="ciudad.idMunicipio"> {{ ciudad.nombre | uppercase}}</option>
                            </select>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="cp">Código Postal</label>
                            <input [(ngModel)]="cp" name="cp" type="text" class="form-control" id="cp" pattern="[0-9]{5}" >
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="giro">Giro de la empresa</label>
                            <input [(ngModel)]="giro" name="giro" type="text" class="form-control" id="giro">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="nombreContacto">Nombre del contacto</label>
                            <input [(ngModel)]="nombreContacto" name="nombreContacto" type="text" class="form-control" id="nombreContacto">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="apellidoPaterno">Apellido paterno</label>
                            <input [(ngModel)]="apellidoPaterno" name="apellidoPaterno" type="text" class="form-control" id="apellidoPaterno">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="apellidoMaterno">Apellido materno</label>
                            <input [(ngModel)]="apellidoMaterno" name="apellidoMaterno" type="text" class="form-control" id="apellidoMaterno">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="telefonoFijo">Teléfono fijo</label>
                            <input [(ngModel)]="telefonoFijo" name="telefonoFijo" type="tel" class="form-control" id="telefonoFijo" pattern="[0-9]{10}" maxlength="10">
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                            <label for="telefonoMovil">Teléfono móvil</label>
                            <input [(ngModel)]="telefonoMovil" name="telefonoMovil" type="tel" class="form-control" id="telefonoMovil" pattern="[0-9]{10}" maxlength="10">
                        </div>
                        <div class="form-group col-lg-8 text-left">
                            <label for="email">Correo electrónico</label>
                            <input [(ngModel)]="email" name="email" type="email" class="form-control" id="email">
                        </div>
                        <!-- <div class="form-group col-lg-4 col-md-6 text-left">
                            <label for="familia">Familia de interés</label>
                            <select ngModel="familia" name="familia" class="form-control" required>
                                <option> 
                                    
                                </option>
                            </select>
                        </div> -->
                    </div>
    
                    <div class="row upload pb-1" style="width: 100%;">
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="cvEmpresarial">CV empresarial</label>
                            <input type="file" accept="application/pdf" (change)="cvEmpresarialInput($event)"
                                class="form-control-file" id="cvEmpresarial" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="domicilioFiscal">Comprobante de domicilio fiscal</label>
                            <input type="file" accept="application/pdf" (change)="domicilioFiscalInput($event)"
                                class="form-control-file" id="domicilioFiscal" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="situacionFiscal">Comprobante de situación fiscal</label>
                            <input type="file" accept="application/pdf" (change)="situacionFiscalInput($event)"
                                class="form-control-file" id="situacionFiscal" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="estadoCuenta">Estado de cuenta</label>
                            <input type="file" accept="application/pdf" (change)="estadoCuentaInput($event)"
                                class="form-control-file" id="estadoCuenta" required>
                        </div>
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="rfc">RFC</label>
                            <input type="file" accept="application/pdf" (change)="rfcInput($event)"
                                class="form-control-file" id="rfc" required>
                        </div>
    
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="ine">INE (Representante legal)</label>
                            <input type="file" accept="application/pdf" (change)="ineInput($event)"
                                class="form-control-file" id="ine" required>
                        </div>
    
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="imss">Evaluación del IMSS</label>
                            <input type="file" accept="application/pdf" (change)="imssInput($event)"
                                class="form-control-file" id="imss" required>
    
                        </div>
    
                        <div class="form-group col-lg-4 col-md-6">
                            <label for="foto">Foto de la fachada de la empresa</label>
                            <input type="file" accept="image/png, image/jpeg" (change)="fotoInput($event)"
                                class="form-control-file" id="foto" required>
                        </div>

                        <div class="form-group col-lg-4 col-md-6">
                            <label for="ocumpli">Opinión de Cumplimiento</label>
                            <input type="file" accept="application/pdf" (change)="oCumplimientoInput($event)"
                                class="form-control-file" id="ocumpli" required>
                        </div>
                    </div>
                    <button type="submit" class="btn-enviar px-5">Actualizar</button>
                </form>
			</div>
            <div class="alerta-exito blqCtr text-center" *ngIf="this.success">
                <img class="ico-confirmar" src="./../../../../assets/images/icons/icono-exito.png">
                <p>Información <strong>actualizada</strong> correctamente</p>
                <button class="btn-confirmar" (click)="closeok()">Aceptar</button>
            </div>

		</div>
	</div>

</div>